import { RouteObject } from "react-router-dom";

import FlaminemImportExport from "src/web-components/FlaminemImportExport.tsx";

export const importExportRoutes: RouteObject[] = [
  {
    path: "/import-export/*",
    Component: FlaminemImportExport,
  },
];
